module.exports = __webpack_public_path__ + "static/media/dashboard_white.9d92fe69.svg";